import {useMainSalesCarousel} from "../model/hooks/useMainSalesCarousel";
import {Svg} from "@/shared/ui/Svg";
import {Link} from "@/shared/ui/Link";
import {Picture} from "@/shared/ui/Picture";
import {Button} from "@/shared/ui/Button";
import styles from "./MainSales.module.scss";
import classNames from "classnames";

type Sales = {
    alias: string;
    id: number;
    img?: string;
    img_mobile?: string;
    name: string;
}

type Props = {
    sales: Sales[];
    title: string;
    description: string;
    link: string;
    linkName: string;
    path: string;
    mobilePath: string;
    alt: string;
}

export const MainSales = ({sales, title, description, link, linkName}: Props) => {
    const {
        carouselRef,
        onPrevButtonClick,
        onNextButtonClick,
        prevBtnDisabled,
        nextBtnDisabled
    } = useMainSalesCarousel();

    return (
        <div className={styles.container}>
            <div className={`globalContainer`}>
                <div className={styles.carousel}>
                    <div className={styles.saleInfoContainer}>
                        <p className={styles.title}>{title}</p>
                        <p className={styles.description}>{description}</p>
                        <Link href={link} className={styles.link}>
                            <Button variant={`secondary`} fullWidth>{linkName}</Button>
                        </Link>
                    </div>
                    <div ref={carouselRef} className={styles.carouselViewport}>
                        <div className={styles.carouselContainer}>
                            {sales.map((sale) => {
                                return (
                                    <Link
                                        key={sale.id}
                                        href={`/stocks/${sale.alias}`}
                                        className={styles.carouselSlide}
                                    >
                                        <div className={styles.carouselInner}>
                                            {/*<div className={styles.slideContent}>*/}
                                            {/*    <p className={styles.slideTitle}>{sale.name}</p>*/}
                                            {/*</div>*/}
                                            <Picture src={sale.img} srcMobile={sale.img_mobile} alt={sale.name} />
                                        </div>
                                    </Link>
                                );
                            })}
                        </div>
                    </div>
                </div>
            </div>
            {sales.length > 1 && (
                <>
                    <button
                        type={`button`}
                        className={classNames(styles.button, styles.prev, {[styles.hidden]: prevBtnDisabled})}
                        onClick={onPrevButtonClick}
                    >
                        <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                    </button>
                    <button
                        type={`button`}
                        className={classNames(styles.button, styles.next, {[styles.hidden]: nextBtnDisabled})}
                        onClick={onNextButtonClick}
                    >
                        <Svg id={`arrowRight`} className={styles.arrowIcon} />
                    </button>
                </>
                // <div className={styles.buttons}>
                //     <button type={`button`} className={styles.button} onClick={scrollPrev}>
                //         <Svg id={`arrowLeft`} className={styles.arrowIcon} />
                //     </button>
                //     <button type={`button`} className={styles.button} onClick={scrollNext}>
                //         <Svg id={`arrowRight`} className={styles.arrowIcon} />
                //     </button>
                // </div>
            )}
        </div>
    );
}
